import { Tag } from "antd";
import DetailItem from "./DetailItem";

const Details = ({ data }) => {
  return (
    <div className="flex flex-col gap-5">
      <DetailItem title="Subject" value={data?.subject} />
      {data?.description ? (
        <DetailItem title="Description" value={data?.description} />
      ) : null}
      <div className="flex flex-wrap gap-10">
        <DetailItem title="Quote Number" value={data?.quoteNumber} />
        <DetailItem title="Type" value={data?.type} />
        <div className="flex flex-col space-y-1">
          <span className="font-bold text-sm">Status</span>
          <Tag
            className={`capitalize text-white border-none px-2 w-fit flex items-center justify-center rounded-full ${
              data?.status === "open" ? "bg-green-500" : "bg-red-500"
            }`}
          >
            {data?.status}
          </Tag>
        </div>
        <div className="flex flex-col space-y-1">
          <span className="font-bold text-sm">Priority</span>
          <Tag
            className={`capitalize text-white border-none px-2 w-fit flex items-center justify-center rounded-full ${
              data?.priority === "Low"
                ? "bg-green-500"
                : data?.priority === "Medium"
                ? "bg-yellow-500"
                : data?.priority === "High"
                ? "bg-red-500"
                : "bg-red-900"
            }`}
          >
            {data?.priority}
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default Details;
